import { render } from "./DataleftCardright.vue?vue&type=template&id=f5b99096&scoped=true"
import script from "./DataleftCardright.vue?vue&type=script&lang=js"
export * from "./DataleftCardright.vue?vue&type=script&lang=js"

import "./DataleftCardright.vue?vue&type=style&index=0&id=f5b99096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b99096"]])

export default __exports__